import { Helpers } from 'application/Shared/Helpers';
import { TenantApp } from 'application/Shared/types/tenantApp';

import { ColumnFilter } from '../Table/types';
import { sourcesFilter } from './SourcesFilter';

const { defaultOptions } = sourcesFilter;

export const tenantAppSourcesFilter: ColumnFilter<TenantApp> = {
    clientSideFiltering: true,
    defaultOptions,
    filterFn: (row, filterValue) => {
        const filterValueArray = Array.isArray(filterValue)
            ? filterValue
            : [filterValue];

        if (filterValue.length === 0) return true;
        const sources = Helpers.getSources(row);
        return filterValueArray.some((source) => sources[source]);
    }
};
